import { AppBar, Box, Toolbar } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

import TrackButton from 'artkive/components/Tracker/TrackButton'

export const TopBar = withStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.white,
    boxShadow: 'none',
  },
}))(AppBar)

export const OuterToolbar = withStyles(() => ({
  root: {
    position: 'relative',
    padding: 0,
  },
}))(Toolbar)

export const InnerToolbar = withStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.white,
    boxShadow: theme.customShadows[4],
    width: '100%',
    zIndex: 1100,
    paddingRight: '16px',
    paddingLeft: '4px',
    display: 'grid',
    gridTemplateColumns: '48px 164px auto',
    alignItems: 'unset',
    [theme.breakpoints.up('sm')]: {
      paddingRight: '24px',
      paddingLeft: '12px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '0 16px',
      gridTemplateColumns: '1fr auto 1fr',
    },
    ['@media (min-width: 1366px)']: {
      gridTemplateColumns: '1fr auto 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 50px',
    },
  },
}))(Toolbar)

export const CTAWrapper = withStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
}))(Box)

export const GetStartedButton = withStyles((theme) => ({
  root: {
    height: 36,
    width: 118,
    fontSize: '0.875rem',
    borderWidth: '1px',
    [theme.breakpoints.up('md')]: {
      height: 48,
      width: 160,
      fontSize: '1rem',
      borderWidth: '2px',
    },
  },
}))(TrackButton)

export const MenuButton = withStyles((theme) => ({
  root: {
    color: theme.colors.grey[700],
    margin: 0,
  },
}))(IconButton)
